import activeLink from './activeLink'
import email from './email'

module.exports = {
  ...activeLink,
  ...email
}



// WEBPACK FOOTER //
// ./src/redux/types/index.js